var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState, useRef, } from 'react';
import axios from 'axios';
import { Empty, Spin } from 'antd';
import url from 'url';
import qs from 'query-string';
import * as R from 'ramda';
import { trailingSlash } from '../../utils';
import { useQuery } from '../../hooks';
import { Tooltip } from '../Tooltip';
import { Label } from '../Input/styled';
import { Highlighter } from '../Highlighter';
import { NotFoundContent, TagPlaceholder } from './components';
import { Select as StyledSelect, Action, EmptyWrapper, Button, CustomActions, } from './styled';
import './dropDownStyle.css';
import { setFiltersToLocalStorage, getDataFromLocalStorage, } from '../../helpers/localStorage';
import { cachedRequest } from './utils';
var Select = function (_a) {
    var onCreateNewOption = _a.onCreateNewOption, createNewOptionText = _a.createNewOptionText, onSearch = _a.onSearch, onBlur = _a.onBlur, apiUrl = _a.apiUrl, _b = _a.applySingle, applySingle = _b === void 0 ? false : _b, additionalField = _a.additionalField, onAdditionalFieldClick = _a.onAdditionalFieldClick, propsOptions = _a.options, propsValue = _a.value, customOptions = _a.customOptions, _c = _a.customActions, customActions = _c === void 0 ? [] : _c, _d = _a.name, name = _d === void 0 ? '' : _d, renderOption = _a.renderOption, _e = _a.loadOnOpen, loadOnOpen = _e === void 0 ? false : _e, _f = _a.loadOption, loadOption = _f === void 0 ? false : _f, _g = _a.loadOptions, loadOptions = _g === void 0 ? false : _g, _h = _a.loadOnEveryOpen, loadOnEveryOpen = _h === void 0 ? false : _h, _j = _a.loadOnBlur, loadOnBlur = _j === void 0 ? true : _j, localStorageKey = _a.localStorageKey, onLoaded = _a.onLoaded, onFirstLoad = _a.onFirstLoad, labelInValue = _a.labelInValue, selectAll = _a.selectAll, _k = _a.highlightSearch, highlightSearch = _k === void 0 ? false : _k, _l = _a.valueProp, valueProp = _l === void 0 ? 'id' : _l, _m = _a.valueToString, valueToString = _m === void 0 ? false : _m, _o = _a.resetIfPreloadEmpty, resetIfPreloadEmpty = _o === void 0 ? false : _o, onManualSetValue = _a.onManualSetValue, label = _a.label, _p = _a.useCache, useCache = _p === void 0 ? false : _p, invalidateCacheTime = _a.invalidateCacheTime, maxCacheLength = _a.maxCacheLength, maxTagPlaceholderGetLabelText = _a.maxTagPlaceholderGetLabelText, notFoundContentProps = _a.notFoundContentProps, _q = _a.fullWidth, fullWidth = _q === void 0 ? false : _q, _r = _a.hasError, hasError = _r === void 0 ? false : _r, renderOptions = _a.renderOptions, props = __rest(_a, ["onCreateNewOption", "createNewOptionText", "onSearch", "onBlur", "apiUrl", "applySingle", "additionalField", "onAdditionalFieldClick", "options", "value", "customOptions", "customActions", "name", "renderOption", "loadOnOpen", "loadOption", "loadOptions", "loadOnEveryOpen", "loadOnBlur", "localStorageKey", "onLoaded", "onFirstLoad", "labelInValue", "selectAll", "highlightSearch", "valueProp", "valueToString", "resetIfPreloadEmpty", "onManualSetValue", "label", "useCache", "invalidateCacheTime", "maxCacheLength", "maxTagPlaceholderGetLabelText", "notFoundContentProps", "fullWidth", "hasError", "renderOptions"]);
    var _s = useQuery(), query = _s.query, pushQuery = _s.pushQuery;
    var hasSearchValue = useRef('');
    var _t = __read(useState(''), 2), searchValue = _t[0], setSearchValue = _t[1];
    var _u = __read(useState(), 2), currentValue = _u[0], setCurrentValue = _u[1];
    var _v = __read(useState(false), 2), isLoading = _v[0], setIsLoading = _v[1];
    var _w = __read(useState(false), 2), isFetchSearchLoading = _w[0], setIsFetchSearchLoading = _w[1];
    var _x = __read(useState(customOptions || propsOptions || []), 2), options = _x[0], setOptions = _x[1];
    var _y = __read(useState(false), 2), dropdownVisible = _y[0], setDropdownVisible = _y[1];
    var initialLocalStorageData = getDataFromLocalStorage(localStorageKey || '');
    var optionsIds = useMemo(function () { return options.map(function (_a) {
        var value = _a.value;
        return (valueToString ? String(value) : value);
    }); }, [options, valueToString]);
    var isSelectAllBtnVisible = useMemo(function () { return props.mode === 'multiple' && selectAll && !R.equals(currentValue, optionsIds); }, [props.mode, selectAll, currentValue, optionsIds]);
    useEffect(function () {
        if (!localStorageKey || !initialLocalStorageData)
            return;
        var localStorageArrayKeys = Object.keys(initialLocalStorageData);
        var savedSelectsValuesObject = localStorageArrayKeys.reduce(function (acc, el) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[el] = initialLocalStorageData[el].value, _a)));
        }, {});
        pushQuery(__assign(__assign({}, query), savedSelectsValuesObject));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorageKey]);
    useEffect(function () {
        if (customOptions || propsOptions) {
            setOptions(customOptions || propsOptions);
        }
    }, [customOptions, propsOptions]);
    var fetchOptions = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var data, resp, resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!apiUrl)
                        return [2 /*return*/, []];
                    if (!useCache) return [3 /*break*/, 2];
                    return [4 /*yield*/, cachedRequest(axios.get, apiUrl, params, invalidateCacheTime, maxCacheLength)];
                case 1:
                    resp = _b.sent();
                    if (!resp) {
                        return [2 /*return*/, []];
                    }
                    data = resp.data;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, axios.get(apiUrl, { params: params })];
                case 3:
                    resp = _b.sent();
                    data = resp.data;
                    _b.label = 4;
                case 4: return [2 /*return*/, (((_a = data.results) === null || _a === void 0 ? void 0 : _a.map(function (option) { return (__assign(__assign({}, option), { label: renderOption ? renderOption(option) : option.name, value: option[valueProp] })); })) || [])];
            }
        });
    }); }, [apiUrl, useCache, invalidateCacheTime, maxCacheLength, renderOption, valueProp]);
    var fetchData = useCallback(function (search) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedData, idToLoad_1, idsToLoad, loadedIds_1, ids, data, _a, parsedUrl, itemUrl, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fetchedData = [];
                    if (!apiUrl) {
                        !onSearch && console.error('apiUrl is undefined');
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 9, 10, 11]);
                    setIsLoading(true);
                    return [4 /*yield*/, fetchOptions({ search: search })];
                case 2:
                    fetchedData = _b.sent();
                    if (!(loadOption || loadOptions)) return [3 /*break*/, 8];
                    idToLoad_1 = [];
                    if (labelInValue) {
                        if (query[name]) {
                            idToLoad_1 = query[name] || [];
                        }
                        if (props.defaultValue) {
                            idToLoad_1 = props.defaultValue.value;
                        }
                        if (propsValue) {
                            idToLoad_1 = propsValue.value;
                        }
                    }
                    else {
                        idToLoad_1 = propsValue || props.defaultValue || query[name] || [];
                    }
                    if (!loadOptions) return [3 /*break*/, 6];
                    idsToLoad = idToLoad_1 && !Array.isArray(idToLoad_1) ? [idToLoad_1] : idToLoad_1 || [];
                    loadedIds_1 = fetchedData.map(function (item) { return String(item.value); });
                    ids = idsToLoad.filter(function (id) { return !loadedIds_1.includes(String(id)); });
                    if (!ids.length) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchOptions({ ids: String(ids) })];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = [];
                    _b.label = 5;
                case 5:
                    data = _a;
                    if (resetIfPreloadEmpty && ids.length && !data.length) {
                        setCurrentValue(undefined);
                        onManualSetValue && onManualSetValue(undefined);
                    }
                    fetchedData.push.apply(fetchedData, __spreadArray([], __read(data), false));
                    return [3 /*break*/, 8];
                case 6:
                    if (!(idToLoad_1 &&
                        !Array.isArray(idToLoad_1) && // idToLoad is simple value
                        !fetchedData.find(function (item) { return String(item.value) === String(idToLoad_1); }))) return [3 /*break*/, 8];
                    parsedUrl = qs.parseUrl(apiUrl);
                    itemUrl = url.format({
                        pathname: "" + trailingSlash(parsedUrl.url) + idToLoad_1,
                        query: parsedUrl.query,
                    });
                    return [4 /*yield*/, axios.get(itemUrl)];
                case 7:
                    data = (_b.sent()).data;
                    fetchedData.push(__assign(__assign({}, data), { label: renderOption ? renderOption(data) : data.name, value: data[valueProp] }));
                    _b.label = 8;
                case 8:
                    setOptions(fetchedData);
                    return [3 /*break*/, 11];
                case 9:
                    error_1 = _b.sent();
                    console.error('Error from Select: ', error_1);
                    return [3 /*break*/, 11];
                case 10:
                    setIsLoading(false);
                    onLoaded && onLoaded(fetchedData);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/, fetchedData];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        apiUrl,
        onSearch,
        name,
        query,
        loadOption,
        renderOption,
        labelInValue,
        props.defaultValue,
        propsValue,
        onLoaded,
        loadOptions,
        fetchOptions,
    ]);
    // Init fetch data
    useEffect(function () {
        if (loadOnOpen)
            return;
        function initFetch() {
            return __awaiter(this, void 0, void 0, function () {
                var fetchedData, optionsValues;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!apiUrl) return [3 /*break*/, 2];
                            return [4 /*yield*/, fetchData()];
                        case 1:
                            fetchedData = _a.sent();
                            optionsValues = (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.map(function (option) { return String(option.value); })) || [];
                            onFirstLoad && onFirstLoad(optionsValues);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        initFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiUrl, onFirstLoad]);
    useEffect(function () {
        setCurrentValue(propsValue);
    }, [propsValue]);
    useEffect(function () {
        if (applySingle && options.length === 1) {
            var _a = __read(options, 1), value = _a[0].value;
            setCurrentValue(props.mode === 'multiple' ? [String(value)] : String(value));
        }
    }, [searchValue, applySingle, props.mode, options]);
    var notFoundContent = isLoading ? (React.createElement(Spin, { size: 'small' })) : onCreateNewOption ? (React.createElement(NotFoundContent, { createNewOptionText: createNewOptionText, search: searchValue, onClick: onCreateNewOption })) : (React.createElement(EmptyWrapper, null,
        React.createElement(Empty, { description: (notFoundContentProps === null || notFoundContentProps === void 0 ? void 0 : notFoundContentProps.emptyDescription) || 'Ничего не найдено' })));
    var handleSetSearchValue = useCallback(function (search) {
        setSearchValue(search);
        hasSearchValue.current = search;
    }, []);
    // - Start - Последовательные рекурсивные запросы поиска
    var handleFetchSearch = useCallback(function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsFetchSearchLoading(true);
                    return [4 /*yield*/, fetchData(searchText).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (searchText === hasSearchValue.current) {
                                            setIsFetchSearchLoading(false);
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, handleFetchSearch(hasSearchValue.current)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [fetchData]);
    useEffect(function () {
        if (isFetchSearchLoading)
            return;
        handleFetchSearch(searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);
    // - End -
    var handleSearch = useCallback(function (search) {
        handleSetSearchValue(search);
        onSearch && onSearch(search);
    }, [handleSetSearchValue, onSearch]);
    var handleBlur = useCallback(function (e) {
        handleSetSearchValue('');
        loadOnBlur && fetchData();
        onBlur && onBlur(e);
    }, [handleSetSearchValue, loadOnBlur, fetchData, onBlur]);
    var handleChange = useCallback(function (value, options) {
        setCurrentValue(value);
        if (localStorageKey) {
            setFiltersToLocalStorage(localStorageKey, name, options);
        }
        props.onChange && props.onChange(value, options);
    }, [localStorageKey, name, props]);
    var handleClear = useCallback(function () { return handleChange([], []); }, [handleChange]);
    var maxTagPlaceholder = useCallback(function (selectedValues) { return (React.createElement(TagPlaceholder, { count: selectedValues.length, getLabelText: maxTagPlaceholderGetLabelText, onClose: handleClear })); }, [handleClear, maxTagPlaceholderGetLabelText]);
    var handleSelect = useCallback(function (value, option) {
        if (value === (additionalField === null || additionalField === void 0 ? void 0 : additionalField.name) && onAdditionalFieldClick) {
            onAdditionalFieldClick();
        }
        if (apiUrl && searchValue) {
            fetchData(props.mode === 'multiple' ? searchValue : undefined);
        }
        if (props.mode !== 'multiple')
            setSearchValue('');
        var selectedValue = options.find(function (el) { return el[valueProp] == option.value; }); // TODO: remove any
        props.onSelect && props.onSelect(value, option, selectedValue);
    }, [
        additionalField === null || additionalField === void 0 ? void 0 : additionalField.name,
        onAdditionalFieldClick,
        apiUrl,
        searchValue,
        fetchData,
        options,
        props,
        valueProp,
    ]);
    var handleOpen = useCallback(function (open) {
        if (open && apiUrl && ((loadOnOpen && !options.length) || loadOnEveryOpen)) {
            fetchData();
        }
        setDropdownVisible(open);
        props.onDropdownVisibleChange && props.onDropdownVisibleChange(open);
    }, [apiUrl, loadOnOpen, options.length, loadOnEveryOpen, props, fetchData]);
    var handleSelectAll = useCallback(function () {
        handleChange(optionsIds, options);
    }, [options, handleChange, optionsIds]);
    return (React.createElement(React.Fragment, null,
        label && React.createElement(Label, null, label),
        React.createElement(StyledSelect, __assign({ value: currentValue, notFoundContent: notFoundContent, maxTagCount: 0, maxTagPlaceholder: maxTagPlaceholder, filterOption: false, optionFilterProp: 'label', dropdownClassName: 'dropDownRender', loading: isLoading || isFetchSearchLoading, getPopupContainer: function (trigger) {
                return trigger.parentElement || document.body;
            } }, props, { dropdownRender: function (menu) {
                return (React.createElement("div", null,
                    additionalField && onAdditionalFieldClick && (React.createElement(Action, { key: additionalField.name, onClick: onAdditionalFieldClick }, additionalField.label)),
                    menu,
                    isSelectAllBtnVisible && (React.createElement(Button, { type: 'primary', onClick: handleSelectAll }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0451")),
                    customActions.length > 0 && (React.createElement(CustomActions, null, customActions.map(function (action) {
                        var _a, _b;
                        return (React.createElement(Tooltip, { key: action.name, title: (_a = action.tooltip) === null || _a === void 0 ? void 0 : _a.title, placement: (_b = action.tooltip) === null || _b === void 0 ? void 0 : _b.placement },
                            React.createElement(Button, { onClick: action.onClick }, action.label)));
                    })))));
            }, onChange: handleChange, onSearch: props.showSearch && handleSearch, onSelect: handleSelect, onBlur: handleBlur, onDropdownVisibleChange: handleOpen, dropdownVisible: dropdownVisible, labelInValue: labelInValue, "$fullWidth": fullWidth, "$hasError": hasError }), !isFetchSearchLoading && (React.createElement(React.Fragment, null,
            options.length && additionalField && !onAdditionalFieldClick && (React.createElement(StyledSelect.Option, { key: additionalField.name, label: additionalField.label }, additionalField.label)),
            renderOptions
                ? renderOptions(options, searchValue)
                : options.map(function (d) { return (React.createElement(StyledSelect.Option, { key: String(d.value), label: d.label, value: valueToString ? undefined : d.value, disabled: d === null || d === void 0 ? void 0 : d.disabled }, highlightSearch ? (React.createElement(Highlighter, { optionLabel: d.label, searchValue: searchValue.split(' ') })) : (d.label))); }))))));
};
Select.defaultProps = {
    placeholder: 'Выберите',
};
export default Select;
//# sourceMappingURL=Select.js.map